import RegisterApi from "api/counter/register.api"
import { removeItem as removeSecureItem } from 'utils/secureStorage'

export enum CLINIC_THEME {
  DENTAL = 'DENTAL',
  PLUS = 'PLUS'
}

export interface ClinicThemeInterface {
  type: CLINIC_THEME
  theme: CLINIC_THEME
}

export enum EXPENSE_GROUP {
  INCOME = `INCOME`,
  EXPENSE = `EXPENSE`
}

export enum FIXED {
  FIXED = `FIXED`,
  NOT_FIXED = `NOT_FIXED`
}

export const SCOPE = {
  FIXED: {
    ...FIXED
  },
  IS_DEFAULT: {
    IS_DEFAULT: `1`,
    IS_NOT_DEFAULT: `0`
  }
}

export enum TIME_DURATION_TYPE {
  MINUTES = `MINUTES`,
  HOURS = `HOURS`,
  DAY = `DAY`,
  MONTH = `MONTH`
}

export const MEMBERSHIP_RANKING = [
  { key: `BRONZ`, text: `Bronze Member`, class: `bronze-member` },
  { key: `SILVER`, text: `Silver Member`, class: `silver-member` },
  { key: `GOLD`, text: `Gold Member`, class: `gold-member` },
  { key: `PLATINUM`, text: `Platinum Member`, class: `platinum-member` },
  { key: `DIMON`, text: `Diamond Member`, class: `daimon-member` }
]



export const RANKS = []

export enum MEMBER_RANKING_TYPE {
  BRONZE = 'bronz',
  SILVER = 'silver',
  GOLD = 'gold',
  PLATINUM = 'platinum',
  DIAMOND = 'dimon'
}

export enum KEY_STORAGE {
  TOKEN = 'TOKEN',
  PERMISSION = 'PERMISSION',
  SERVICE_POINT = 'SERVICE_POINT',
  PACKAGE = 'PACKAGE',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  PATIENT = 'PATIENT',
  FILTER_PATIENT_ALL_BRANCH = 'FILTER_PATIENT_ALL_BRANCH',
  FILTER_PATIENT_CONDITION = 'FILTER_PATIENT_CONDITION',
  PROFILE = 'PROFILE',
  CLINIC_INFO = 'CLINIC_INFO',
  DATE_FINANCE = 'DATE_FINANCE',
  TREATMENT_CLOSE_POPUP = 'TREATMENT_CLOSE_POPUP',
  TREATMENT_CLOSE_DROPDOWN = 'TREATMENT_CLOSE_DROPDOWN',
  REPORT_CONDITION = 'REPORT_CONDITION',
  LANGUAGE = 'LANGUAGE',
  APP = "APP",
  FORMATAPPOINTMENT = "FORMATAPPOINTMENT",
  DASHBOARD = "DASHBOARD",
  MEMBER_RANKING_TYPE = "MEMBER_RANKING_TYPE",
  HOME = "HOME",
  CRM = "CRM",
  REMITTANCES = "REMITTANCES",
  /** token จาก API ส่งชำระเงิน – ใช้ sync คิว/สถานะ */
  PAYMENT_STATUS_TOKEN = "PAYMENT_STATUS_TOKEN",
  /** key สำหรับ broadcast ว่าเคสถูกส่งชำระเงินแล้ว (ให้แท็บอื่นรับรู้) – ใช้กับ localStorage เท่านั้น */
  PAYMENT_STATUS_SENT_BROADCAST = "PAYMENT_STATUS_SENT_BROADCAST"
}

export enum BMI_RANGE {
  'UNDER_WEIGHT' = 'UNDER_WEIGHT',
  'NORMAL_RANGE' = 'NORMAL_RANGE',
  'PRE_OBESE' = 'PRE_OBESE',
  'OBESE_I' = 'OBESE_I',
  'OBESE_II' = 'OBESE_II',
  'OBESE_III' = 'OBESE_III'
}

export enum SORT_TYPE {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum CHECK_ALL_TYPE {
  'INDETERMINATE' = 'indeterminate',
  'CHECKED' = 'checked'
}

export type BranchObjType = {
  id?: number
  name?: string
}

export type ServicePointsType = {
  branch?: BranchObjType
  servicePoint?: BranchObjType
}

export type PermissionMenusType = {
  shortcuts?: any
  menus?: any
  activeMenu?: any
}

export const removeAllStorage = () => {
  removeSecureItem('BRANCH_ID')
  removeSecureItem('SERVICE_POINT_ID')
  removeSecureItem(KEY_STORAGE.TOKEN)
  removeSecureItem(KEY_STORAGE.PERMISSION)
  removeSecureItem(KEY_STORAGE.SERVICE_POINT)
  removeSecureItem(KEY_STORAGE.PACKAGE)
  removeSecureItem(KEY_STORAGE.SESSION_EXPIRED)
  removeSecureItem(KEY_STORAGE.PATIENT)
  removeSecureItem(KEY_STORAGE.PROFILE)
  removeSecureItem(KEY_STORAGE.CLINIC_INFO)
  removeSecureItem(KEY_STORAGE.DATE_FINANCE)
  removeSecureItem(KEY_STORAGE.TREATMENT_CLOSE_POPUP)
  removeSecureItem(KEY_STORAGE.APP)
  removeSecureItem(KEY_STORAGE.FORMATAPPOINTMENT)
  removeSecureItem(KEY_STORAGE.CRM)
  removeSecureItem(KEY_STORAGE.REMITTANCES)
}

export const removeBranchStorage = () => {
  removeSecureItem('BRANCH_ID')
  removeSecureItem('SERVICE_POINT_ID')
  removeSecureItem(KEY_STORAGE.SERVICE_POINT)
  removeSecureItem(KEY_STORAGE.PERMISSION)
  removeSecureItem(KEY_STORAGE.PATIENT)
}

export const reloadClinicInfoAsMinute = 10
